function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import App from 'modules/App';
import Information from 'modules/Information';
import { INFORMATION_FORM } from '../../constants';
import messages from '../../messages';
import CommunicationConsents from '../CommunicationConsents';
import PrivacyAndHealthData from '../PrivacyAndHealthData';
import SensitiveDataConsents from '../SensitiveDataConsents';
const LegalConsents = ({ isInSection = false })=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const information = useSelector(Information.selectors.information);
    const setFormValues = useAction(App.actions.setFormValues, INFORMATION_FORM);
    const populate = ()=>{
        const { legalConsentApprovals } = information;
        const legalConsentsForm = {};
        legalConsentApprovals.forEach((lca)=>{
            const legalConsent = consentsTemplate.find((consent)=>lca.legalConsentId === consent.legalConsentId && (consent.type === 'PrivacyAndHealthData' || consent.type === 'SensitiveDataAndProfiling' || consent.type === 'Email'));
            if (!legalConsent) {
                return;
            }
            legalConsentsForm[`legalConsent-${lca.legalConsentId}`] = lca.decision.toString();
        });
        setFormValues(legalConsentsForm);
    };
    useEffect(()=>{
        populate();
    }, []);
    if (!consentsTemplate.length) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: `mt-${isInSection ? 0 : 5}`,
        children: [
            /*#__PURE__*/ _jsx("h5", {
                className: "text--h5 mb-3",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.sensitiveDataProfiling))
            }),
            /*#__PURE__*/ _jsx(PrivacyAndHealthData, {}),
            /*#__PURE__*/ _jsx(SensitiveDataConsents, {}),
            /*#__PURE__*/ _jsx("h5", {
                className: "text--h5 mb-3",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.marketingConsents))
            }),
            /*#__PURE__*/ _jsx(CommunicationConsents, {})
        ]
    });
};
export default LegalConsents;
